import './global.js'

import * as Helper from './classes/Helpers'

$(document).ready(function($){
    Helper.fixedHeader();
    Helper.MobileNav();
    Helper.CustomSelect();
    Helper.OpenClose();
    Helper.Tabs();
    Helper.SlickSlider();
    Helper.moveContent();
    Helper.VideoModal();
    Helper.Modal();
    Helper.InitFabricSlider();
    Helper.InitFabricOnScroll();
    Helper.InitFabricHeroWave();
    Helper.Anchor();
    Helper.MatchHeight();
    Helper.initInlineSVG();
    Helper.Share();
    Helper.initToc();
    Helper.MaxCharacter();
    Helper.SearchOpener();
});